import { 
  addDays,
  endOfMonth, 
  startOfMonth, 
  subDays, 
  subMonths, 
  subYears 
} from 'date-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export const useDatePickerShortcuts = () => {
  const{ t } = useI18n();

  //#region computed
  const quickDates = computed(() => {
    return [
      {
        label: t('ui.shortcuts.relative_time_ranges'),
        value: {
          short_title: 'group',
          type: 'group-title',
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_30_days'),
        value: {
          type: 'picker',
          range: [subDays(new Date(), 29), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.this_month'),
        value: {
          type: 'picker',
          range: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.previous_month'),
        value: {
          type: 'picker',
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_90_days'),
        value: {
          type: 'picker',
          range: [subDays(new Date(), 89), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_1_year'),
        value: {
          type: 'picker',
          range: [addDays(subYears(new Date(), 1), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
    ];
  });

  const pickerReportOptions = computed(() => {
    return  [
      {
        label: t('ui.shortcuts.relative_time_ranges'),
        value: {
          short_title: 'group',
          type: 'group-title',
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.this_month_so_far'),
        value: {
          type: 'picker',
          short_title: 'this_month_so_far',
          range: [startOfMonth(new Date()), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.previous_month'),
        value: {
          type: 'picker',
          short_title: 'previous_month',
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_30_days'),
        value: {
          type: 'picker',
          short_title: 'last_30_days',
          range: [subDays(new Date(), 29), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_90_days'),
        value: {
          type: 'picker',
          short_title: 'last_90_days',
          range: [subDays(new Date(), 89), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_6_months'),
        value: {
          type: 'picker',
          short_title: 'last_6_months',
          range: [addDays(subMonths(new Date(), 6), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_1_year'),
        value: {
          type: 'picker',
          short_title: 'last_1_year',
          range: [addDays(subYears(new Date(), 1), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
    ];
  });
  //#endregion

  //#region methods
  const getQuickDates = () => {
    return [
      {
        label: t('ui.shortcuts.relative_time_ranges'),
        value: {
          short_title: 'group',
          type: 'group-title',
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_30_days'),
        value: {
          type: 'picker',
          range: [subDays(new Date(), 29), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.this_month'),
        value: {
          type: 'picker',
          range: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.previous_month'),
        value: {
          type: 'picker',
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_90_days'),
        value: {
          type: 'picker',
          range: [subDays(new Date(), 89), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_1_year'),
        value: {
          type: 'picker',
          range: [addDays(subYears(new Date(), 1), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
    ];
  };
  const getPickerReportOptions = () => {
    return [
      {
        label: t('ui.shortcuts.relative_time_ranges'),
        value: {
          short_title: 'group',
          type: 'group-title',
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.this_month_so_far'),
        value: {
          type: 'picker',
          short_title: 'this_month_so_far',
          range: [startOfMonth(new Date()), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.previous_month'),
        value: {
          type: 'picker',
          short_title: 'previous_month',
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_30_days'),
        value: {
          type: 'picker',
          short_title: 'last_30_days',
          range: [subDays(new Date(), 29), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_90_days'),
        value: {
          type: 'picker',
          short_title: 'last_90_days',
          range: [subDays(new Date(), 89), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_6_months'),
        value: {
          type: 'picker',
          short_title: 'last_6_months',
          range: [addDays(subMonths(new Date(), 6), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
      {
        label: t('ui.shortcuts.last_1_year'),
        value: {
          type: 'picker',
          short_title: 'last_1_year',
          range: [addDays(subYears(new Date(), 1), 1), new Date()],
        },
        slot: 'preset-date-range-button',
      },
    ];
  };
  const checkPeriod = ({ datePeriod, dateRange }: { datePeriod: string, dateRange: Date[] }) => {
    const curPeriod = datePeriod && getPickerReportOptions().find((el) => el.value.short_title === datePeriod);
    if (curPeriod) {
      return {
        datePeriod,
        dateRange: curPeriod.value.range!,
      };
    }

    return {
      datePeriod: null,
      dateRange,
    };
  };
  //#endregion

  return {
    quickDates,
    pickerReportOptions,

    getQuickDates,
    getPickerReportOptions,
    checkPeriod,
  }
}